import styles from "./RefuseBiometrics.module.scss";

import infoIcon from "../../../assets/icons/info-light-icon.svg";
import FullScreenMobilePage from "../../FullScreenMobilePage/FullScreenMobilePage";
import Button from "../../Button/Button";

interface Props {
  handleRefuseBiometrics: () => void;
}

const RefuseBiometrics = (props: Props) => {
  const { handleRefuseBiometrics } = props;
  const { content, footer } = styles;

  return (
    <FullScreenMobilePage
      noLogo
      footerContent={
        <section className={footer}>
          <Button
            variant="primary"
            text="Aceptar"
            onPress={handleRefuseBiometrics}
          />
        </section>
      }
    >
      <div className={content}>
        <img src={infoIcon} alt="Ícono de información" />
        <h1>Configuración de factor biométrico</h1>
        <p>
          Podés activar el factor biométrico en cualquier momento desde la
          sección Mi perfil
        </p>
      </div>
    </FullScreenMobilePage>
  );
};

export default RefuseBiometrics;
